import { type PropertyNames } from '../utility-types';

export type Properties<T> = Required<Pick<T, PropertyNames<T>>>;

export type ArrayPropertyNames<T> = {
  [K in keyof T]: T[K] extends unknown[] ? K : never;
}[keyof T];

export type ArrayProperties<T> = Pick<T, ArrayPropertyNames<T>>;
